// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React from 'react';
import {ROUTES} from '@pub/constants.js';
import {Text} from '@pub/comp/text';
import {Email_input} from './common.js';
import {handle_reset} from './handlers.js';

function Reset_inputs(){
    return <Email_input/>;
}

export const meta = {
    title: 'Reset password',
    details: 'Enter your email address and we\'ll send you instructions'
        +' on how to get your new password. You may need to check'
        +' your spam folder.',
    submit_label: 'Send me reset password link',
    form_comp: Reset_inputs,
    nav_href: ROUTES.AUTH_SIGNIN,
    nav_label: 'Back to Log in',
    on_submit: handle_reset,
    submitted_content: <div>
      <Text.s h2>Reset password link was sent</Text.s>
      <Text.xs>
        If the email address provided exists in our system,
        you will receive an email to reset your password.
      </Text.xs>
      <Text.xs>
        If you do not receive instructions within a few minutes,
        check your email's spam and junk filters.
      </Text.xs>
    </div>,
};
